import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-redirect-layout',
  templateUrl: './redirect-layout.component.html',
  styleUrls: ['./redirect-layout.component.scss']
})
export class RedirectLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
